
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Bandratopunecab() {



    const cardData =
    {
        keyword: 'Bandra to Pune Cab ',
        heading: 'Skyline Cabs:  Bandra to Pune Cab',
        headingDescription: 'Skyline Cabs offers safe, reliable, and affordable Bandra to Pune Cab services for a comfortable intercity journey. Whether you are traveling for business meetings, personal visits, or airport transfers, our experienced drivers and well-maintained vehicles ensure a smooth ride from Bandra to Pune. Enjoy on-time pickups, transparent pricing, and 24/7 customer support. Book your Bandra to Pune cab with Skyline Cabs today and travel stress-free in comfort and style.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Bandra Terminus to Pune Cab",
      "description": "Skyline Cabs offers reliable cab service from Bandra Terminus to Pune with multiple vehicle options including sedan, Ertiga, and Innova Crysta. Enjoy hassle-free booking, on-time pickups, and comfortable travel with experienced drivers."
    },
    {
      "name": "Bandra Terminus to Pune Taxi Fare",
      "description": "Get transparent and affordable taxi fare from Bandra Terminus to Pune. Skyline Cabs ensures no hidden charges—our pricing includes fuel, tolls, and driver charges, making your journey economical and smooth."
    },
    {
      "name": "Bandra to Pune Taxi",
      "description": "Travel from Bandra to Pune comfortably with Skyline Cabs' premium taxi services. Ideal for families, solo travelers, and business professionals looking for a dependable and safe ride."
    },
    {
      "name": "Bandra to Pune Taxi Fare",
      "description": "Skyline Cabs offers competitive taxi fares from Bandra to Pune with a variety of options such as one-way or round-trip rides, and vehicle choices from sedans to luxury SUVs."
    },
    {
      "name": "Bandra to Pune One Way Taxi",
      "description": "Book a one-way taxi from Bandra to Pune with Skyline Cabs for a cost-effective and convenient travel solution. Perfect for those looking to travel without worrying about return plans."
    },
    {
      "name": "Taxi from Bandra Terminus to Pune",
      "description": "Catch a taxi directly from Bandra Terminus to Pune with Skyline Cabs. Our drivers ensure timely arrival, safe driving, and seamless end-to-end travel with real-time tracking."
    },
    {
      "name": "Bandra to Pune Drop Taxi",
      "description": "Looking for a drop taxi from Bandra to Pune? Skyline Cabs provides point-to-point service for travelers needing a quick and stress-free drop with no return obligation."
    },
    {
      "name": "Bandra to Pune Innova Taxi Fare",
      "description": "Enjoy a spacious and luxurious ride from Bandra to Pune in an Innova with Skyline Cabs. Our all-inclusive fares cover tolls and fuel with flexible booking options for families and groups."
    },
    {
      "name": "Bandra to Pune Ertiga Car Fare",
      "description": "Book an Ertiga from Bandra to Pune for a comfortable and budget-friendly ride. Skyline Cabs ensures reliable service with ample luggage space and AC comfort for longer journeys."
    },
    {
      "name": "Bandra to Pune Round Trip Cab Booking",
      "description": "Plan your full journey with round-trip cab booking from Bandra to Pune. Skyline Cabs offers convenient scheduling, professional drivers, and clean, sanitized cars for a safe ride."
    },
    {
      "name": "Mumbai to Pune Taxi Fare",
      "description": "Skyline Cabs provides citywide cab booking across Mumbai to Pune. Get the best taxi fares whether you're traveling from Bandra, Andheri, or the airport—comfort and reliability guaranteed."
    },
    {
      "name": "Mumbai to Pune Car Rental",
      "description": "Choose Skyline Cabs for your Mumbai to Pune car rental needs. Pick from a range of vehicles including hatchbacks, sedans, and SUVs for personal or corporate travel."
    },
    {
      "name": "Bandra Kurla Complex to Pune Cab",
      "description": "Travel from BKC to Pune with Skyline Cabs’ premium intercity taxi service. Enjoy AC cabs, trained chauffeurs, and punctual service for meetings, leisure trips, or airport connections."
    },
    {
      "name": "Bandra Kurla Complex to Pune Cab Fare",
      "description": "Skyline Cabs offers fair and transparent pricing for travel from Bandra Kurla Complex to Pune. Get upfront rates with no hidden charges—perfect for corporate and frequent travelers."
    },
    {
      "name": "Bandra to Pune Innova Crysta Cab",
      "description": "Hire a luxury Innova Crysta for your Bandra to Pune journey. With spacious seating and advanced comfort, it's an ideal option for long-distance travel with family or colleagues."
    },
    {
      "name": "Bandra to Pune Ertiga Cab",
      "description": "For mid-size group travel from Bandra to Pune, book an Ertiga with Skyline Cabs. Affordable and comfortable, our Ertigas are perfect for airport transfers and city-to-city trips."
    },
    {
      "name": "Bandra to Pimpri Chinchwad Cab",
      "description": "Skyline Cabs offers cabs from Bandra to Pimpri Chinchwad with door-to-door service. Choose from budget or premium vehicles based on your needs and enjoy smooth travel to Pune suburbs."
    },
    {
      "name": "Bandra to Outstation Cab Service",
      "description": "Planning a trip beyond Mumbai? Book an outstation cab from Bandra to Pune or other destinations. Skyline Cabs offers safe, convenient, and 24/7 services for intercity travel."
    },
    {
      "name": "Bandra Terminus Taxi Service for Outstation",
      "description": "Skyline Cabs provides reliable taxi service from Bandra Terminus for all your outstation travel needs. Choose us for professional drivers, clean vehicles, and flexible ride options."
    },
    {
      "name": "Cab Service in Bandra Mumbai",
      "description": "Skyline Cabs is your local cab provider in Bandra, Mumbai. Book us for airport transfers, outstation trips like Pune, or daily city rides—always prompt, clean, and reliable."
    }
  ],
  "tableData": [
    ["Bandra Terminus to Pune Cab", "Bandra Terminus to Pune Taxi Fare"],
    ["Bandra to Pune Taxi", "Bandra to Pune Taxi Fare"],
    ["Bandra to Pune One Way Taxi", "Taxi from Bandra Terminus to Pune"],
    ["Bandra to Pune Drop Taxi", "Bandra to Pune Innova Taxi Fare"],
    ["Bandra to Pune Ertiga Car Fare", "Bandra to Pune Round Trip Cab Booking"],
    ["Mumbai to Pune Taxi Fare", "Mumbai to Pune Car Rental"],
    ["Bandra Kurla Complex to Pune Cab", "Bandra Kurla Complex to Pune Cab Fare"],
    ["Bandra to Pune Innova Crysta Cab", "Bandra to Pune Ertiga Cab"],
    ["Bandra to Pimpri Chinchwad Cab", "Bandra to Outstation Cab Service"],
    ["Bandra Terminus Taxi Service for Outstation", "Cab Service in Bandra Mumbai"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Bandra to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers prompt and dependable cab services from Bandra to Pune, ensuring a smooth and timely journey for business travelers, families, and solo passengers alike. With flexible scheduling and on-time pickups, we’re your trusted partner for intercity travel."
    },
    {
        "WhyChooseheading": "Comfortable, Air-Conditioned Vehicles",
        "WhyChoosedescription": "Travel from Bandra to Pune in style and comfort in our well-maintained, air-conditioned cabs. Our fleet includes sedans, SUVs, and luxury cars—each designed to offer you a peaceful, relaxed ride with plenty of legroom and space for your luggage."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our courteous and experienced drivers are trained for long-distance routes like Bandra to Pune. They ensure safe driving, respect your privacy, and are familiar with the fastest and most efficient ways to get you to your destination on time."
    },
    {
        "WhyChooseheading": "Affordable One-Way and Round-Trip Fares",
        "WhyChoosedescription": "Skyline Cabs offers both one-way and round-trip options from Bandra to Pune at competitive rates. Our transparent pricing ensures you only pay for what you use—no hidden fees, no surprises. Get premium service without overpaying."
    },
    {
        "WhyChooseheading": "24/7 Service Availability from Bandra",
        "WhyChoosedescription": "We operate around the clock to accommodate your schedule. Whether you need an early morning departure or a late-night ride, Skyline Cabs is always available to take you from Bandra to Pune comfortably and safely."
    },
    {
        "WhyChooseheading": "Vehicle Choices to Fit Every Need",
        "WhyChoosedescription": "Whether you’re traveling solo, with a partner, or with a group, we have a vehicle to match. From fuel-efficient sedans to spacious SUVs and premium rides for special occasions, Skyline Cabs gives you the freedom to choose based on your travel style."
    },
    {
        "WhyChooseheading": "Instant Booking with Real-Time Tracking",
        "WhyChoosedescription": "Book your Bandra to Pune cab in minutes via our website or mobile app. Enjoy instant confirmation, real-time driver tracking, digital payments, and customer support at your fingertips for a seamless travel experience."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel Guaranteed",
        "WhyChoosedescription": "All our vehicles are GPS-enabled, regularly sanitized, and driven by background-verified professionals. Your safety is our top priority, and we ensure every Bandra to Pune ride is secure, comfortable, and worry-free."
    }
]

















    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Bandra to Pune with Skyline Cabs?',
            answer:
                'It’s quick and easy! Use our website or mobile app to book. Choose Bandra (East or West) as your pickup location and Pune as the destination. Select your vehicle and confirm your trip instantly.',
        },
        {
            id: 2,
            question: 'What vehicle options are available for the Bandra to Pune route?',
            answer:
                'We offer a variety of well-maintained vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and luxury options to fit your comfort and travel needs.',
        },
        {
            id: 3,
            question: 'Is the pricing fixed for a Bandra to Pune cab?',
            answer:
                'Yes, our pricing is completely transparent and fixed. The fare includes tolls, taxes, and driver charges — with no hidden fees.',
        },
        {
            id: 4,
            question: 'Can I book a cab from Bandra Railway Station to Pune?',
            answer:
                'Absolutely. We provide pickups from Bandra Railway Station and nearby areas. Just provide the exact location when booking.',
        },
        {
            id: 5,
            question: 'How long does it take to travel from Bandra to Pune?',
            answer:
                'It generally takes around 3.5 to 4.5 hours depending on traffic. Our drivers are experienced and take the most efficient routes for a smooth journey.',
        },
        {
            id: 6,
            question: 'Can I book a round-trip cab from Bandra to Pune?',
            answer:
                'Yes, we offer both one-way and round-trip services. Simply mention your return date and time while booking, and we’ll handle the rest.',
        },
        {
            id: 7,
            question: 'Are your drivers trained for long-distance travel?',
            answer:
                'Yes, all Skyline drivers are background-verified, experienced, and trained for intercity travel. Your safety and comfort are always a priority.',
        },
        {
            id: 8,
            question: 'Do your cabs support early morning or late night pickups from Bandra?',
            answer:
                'Of course! Skyline Cabs operates 24/7, so whether you need a pickup at dawn or midnight, we’re ready to go.',
        },
        {
            id: 9,
            question: 'Can I modify or cancel my Bandra to Pune booking?',
            answer:
                'Yes, we offer flexible booking policies. You can make changes or cancel your trip through our app, website, or by contacting customer care.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs from Bandra to Pune?',
            answer:
                'Skyline Cabs ensures clean vehicles, professional drivers, fixed fares, and timely service. Whether you’re heading to Pune for work or a weekend getaway, we make the ride smooth and reliable.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rohan Naik",
            rating: 5,
            review: "Booked a Skyline Cab from Bandra East to Pune. The service was flawless — on-time pickup, courteous driver, and very clean car. It was a comfortable and hassle-free ride. Highly recommended!"
        },
        {
            name: "Miss. Meenal Shetty",
            rating: 4,
            review: "I needed a safe ride from Bandra West to Pune late at night and Skyline delivered! The car was comfortable, and the driver drove very responsibly. A small delay at pickup but the rest was perfect."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bandra to Pune Cabs",
  "image": "https://skylinecabs.com/assets/images/bandra-to-pune-cab.jpg",
  "description": "Book Bandra to Pune cabs with Skyline Cabs for safe, affordable, and on-time travel. Choose from AC sedans or SUVs with verified drivers—available 24/7 for one-way and round-trip bookings.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7542"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/bandra-to-pune-cabs"
  }
};



      
     
      


    return (
        <div>
 <Helmet>
  <title>Bandra to Pune Cabs | 24/7 AC Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Bandra to Pune cabs with Skyline Cabs for safe, affordable, and on-time travel. Choose from AC sedans or SUVs with verified drivers—available 24/7 for one-way and round-trip bookings." 
  />
  <meta 
    name="keywords" 
    content="Bandra to Pune Cabs, Cab from Bandra to Pune, One-Way Taxi Bandra to Pune, Round Trip Cab Bandra to Pune, AC Cab Bandra to Pune, SUV Taxi Bandra to Pune, Affordable Cab Bandra to Pune, 24/7 Taxi Bandra to Pune, Skyline Cabs Bandra to Pune, Online Cab Booking Bandra to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/34.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bandratopunecab;